import React from 'react';
import { Button, Menu, Space, Typography } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuFoldOutlined, MenuUnfoldOutlined, ShopOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { adminMenuItems, getAdminMenuGroupKey, getAdminSelectedKey } from './adminMenu';

const { Text } = Typography;

interface AdminSidebarProps {
  collapsed: boolean;
  isMobile: boolean;
  openKeys: string[];
  onOpenKeysChange: (keys: string[]) => void;
  onToggleCollapsed: () => void;
  onNavigate?: () => void;
}

export const AdminSidebar: React.FC<AdminSidebarProps> = ({
  collapsed,
  isMobile,
  openKeys,
  onOpenKeysChange,
  onToggleCollapsed,
  onNavigate,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    navigate(key);
    onNavigate?.();
  };

  return (
    <>
      <style>{`
        .bo-admin-sidebar > .ant-layout-sider-children {
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow: hidden;
        }
        .bo-admin-sidebar .ant-menu-dark .ant-menu-item:hover,
        .bo-admin-sidebar .ant-menu-dark .ant-menu-submenu-title:hover {
          background-color: rgba(255, 255, 255, 0.08) !important;
        }
      `}</style>
      <div
        style={{
          height: 64,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: collapsed ? '0 8px' : '0 16px',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        <Space size={8} style={{ minWidth: 0 }}>
          <ShopOutlined style={{ fontSize: 22, color: 'var(--color-primary)', flexShrink: 0 }} />
          {!collapsed && (
            <Text
              strong
              style={{
                color: '#fff',
                fontSize: 15,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              ERP Gold
            </Text>
          )}
        </Space>

        {!isMobile && (
          <Button
            type="text"
            size="small"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={onToggleCollapsed}
            style={{ color: '#fff' }}
          />
        )}
      </div>

      {!collapsed && (
        <div
          style={{
            padding: '12px 16px',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          <Text style={{ color: '#fff', display: 'block', fontWeight: 600 }}>Quản trị nền tảng</Text>
          <Text style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12 }}>Bảng điều hành vận hành</Text>
        </div>
      )}

      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
      <Menu
        theme="dark"
        mode={collapsed ? 'vertical' : 'inline'}
        selectedKeys={[getAdminSelectedKey(location.pathname)]}
        openKeys={collapsed ? [] : openKeys}
        onOpenChange={(keys) => onOpenKeysChange(keys as string[])}
        defaultOpenKeys={[getAdminMenuGroupKey(location.pathname)]}
        items={adminMenuItems}
        onClick={handleMenuClick}
        style={{ borderRight: 0, background: 'var(--sidebar-bg)' }}
      />
      </div>
    </>
  );
};

export default AdminSidebar;
